import type { TFunction } from 'i18next';
import type { ChartValueColorRule } from '@/entities/dashboards';
import { fmt, slicePaletteBgClassByCode } from '../../utils';
import type { ChartLegendItem } from './ChartLegend';

/**
 * Строки легенды по правилам раскраски: границы правила словами и его цвет.
 *
 * Границы читаются так же, как их задают: обе — промежутком, одна — с той стороны, с которой она
 * задана. Без этого цвет остаётся неназванным, а подсказка при наведении на него не отвечает —
 * она говорит про один элемент, а вопрос «что здесь чем окрашено» задаётся ко всей диаграмме.
 */
export const valueRuleLegendItems = (
  rules: ChartValueColorRule[] | undefined,
  t: TFunction<'qualityDashboard'>,
): ChartLegendItem[] =>
  (rules ?? []).map((rule) => {
    const from = rule.from === undefined ? null : fmt(rule.from);
    const to = rule.to === undefined ? null : fmt(rule.to);
    const label =
      from !== null && to !== null
        ? t('presets.chart.ruleRange', { from, to })
        : from !== null
          ? t('presets.chart.ruleFrom', { from })
          : to !== null
            ? t('presets.chart.ruleTo', { to })
            : t('presets.chart.ruleAnyValue');

    return { colorClass: slicePaletteBgClassByCode(rule.color), label };
  });
